module.exports = __webpack_public_path__ + "static/img/img3.b76eb80.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img3.png
// module id = sFzP
// module chunks = 1